import Chart from 'chart.js/auto';

document.addEventListener('DOMContentLoaded', () => {
    const chartContainers = document.querySelectorAll('.block--diagramme');

    if (chartContainers.length > 0) {
        const chartElements = document.querySelectorAll('.diagramm-chart');

        // Intersection Observer für Viewport-Detection
        const observerOptions = {
            root: null, // viewport
            rootMargin: '50px', // 50px vor dem eigentlichen Eintritt triggern
            threshold: 0.1 // 10% des Elements muss sichtbar sein
        };

        const chartObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !entry.target.dataset.chartInitialized) {
                    // Chart initialisieren wenn es in den Viewport kommt
                    initializeChart(entry.target);
                    entry.target.dataset.chartInitialized = 'true';
                }
            });
        }, observerOptions);

        // Alle Chart-Elemente dem Observer hinzufügen
        chartElements.forEach(element => {
            chartObserver.observe(element);
        });

        function initializeChart(element) {
            const diagrammType = element.dataset.diagrammType;
            let chartData;
            try {
                chartData = JSON.parse(element.dataset.chart || '{}');
            } catch (e) {
                console.error('Error parsing chart data:', e, element.dataset.chart);
                chartData = { labels: [], datasets: [] };
            }

            // Log chartData for debugging
            // console.log('Chart Data for', diagrammType, ':', chartData);

            // Animation-Konfiguration für bessere Viewport-Animation
            const getAnimationConfig = () => ({
                duration: 1500, // 1.5 Sekunden Animation
                easing: 'easeOutQuart',
                delay: (context) => {
                    // Staggered animation für mehrere Datenpunkte
                    return context.type === 'data' && context.mode === 'default' 
                        ? context.dataIndex * 100 
                        : 0;
                }
            });

            if (diagrammType === 'pie') {
                const labels = chartData.length > 0 ? chartData.map(item => item.bezeichnung || 'Unknown') : [];
                const values = chartData.length > 0 ? chartData.map(item => (typeof item.wert === 'number' && !isNaN(item.wert) ? item.wert : 0)) : [];
                const colors = chartData.length > 0 ? chartData.map(item => item.farbe || '#000000') : [];

                // console.log('Labels:', labels);
                // console.log('Values:', values);
                // console.log('Colors:', colors);

                if (labels.length === 0 || values.length === 0) {
                    console.warn('No valid data for pie chart:', chartData);
                    return;
                }

                const canvas = element.querySelector('.chart-canvas');
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: values,
                                backgroundColor: colors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.label || 'Unknown';
                                            const value = context.raw;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
                                                : '0';
                                            return `${label}: ${formattedValue}`;
                                        }
                                    }
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for pie chart');
                }
            } else if (diagrammType === 'line') {
                const labels = chartData.labels || [];
                const datasets = chartData.datasets || [];

                // console.log('Labels:', labels);
                // console.log('Datasets:', datasets);

                if (labels.length === 0 || datasets.length === 0) {
                    console.warn('No valid data for line chart:', chartData);
                    return;
                }

                const canvas = element.querySelector('.chart-canvas');
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: labels,
                            datasets: datasets.map(dataset => ({
                                label: dataset.label || 'Unknown',
                                data: dataset.data,
                                borderColor: dataset.farbe,
                                backgroundColor: dataset.farbe,
                                fill: false,
                                // tension: 0.4,
                                pointRadius: 3,
                                pointHoverRadius: 5
                            }))
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.dataset.label || 'Unknown';
                                            const value = context.raw;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
                                                : '0';
                                            return `${label}: ${formattedValue}`;
                                        }
                                    }
                                }
                            },
                            scales: {
                                x: {
                                    title: {
                                        display: false
                                    }
                                },
                                y: {
                                    title: {
                                        display: false
                                    }
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for line chart');
                }
            } else if (diagrammType === 'area') {
                const labels = chartData.labels || [];
                const datasets = chartData.datasets || [];

                // console.log('Labels:', labels);
                // console.log('Datasets:', datasets);

                if (labels.length === 0 || datasets.length === 0) {
                    console.warn('No valid data for area chart:', chartData);
                    return;
                }

                const canvas = element.querySelector('.chart-canvas');
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: labels,
                            datasets: datasets.map(dataset => ({
                                label: dataset.label || 'Unknown',
                                data: dataset.data,
                                rawData: dataset.rawData,
                                borderColor: dataset.farbe,
                                backgroundColor: dataset.farbe,
                                fill: true,
                                tension: 0.4,
                                pointRadius: 0,
                                pointHoverRadius: 0
                            }))
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    mode: 'index',
                                    intersect: false,
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.dataset.label || 'Unknown';
                                            const index = context.dataIndex;
                                            // console.log('Tooltip Debug:', {
                                            //     label,
                                            //     index,
                                            //     rawData: context.dataset.rawData,
                                            //     data: context.dataset.data
                                            // });
                                            const value = Array.isArray(context.dataset.rawData) && index < context.dataset.rawData.length
                                                ? context.dataset.rawData[index]
                                                : 0;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
                                                : '0';
                                            return `${label}: ${formattedValue}`;
                                        }
                                    }
                                }
                            },
                            scales: {
                                x: {
                                    stacked: true,
                                    title: {
                                        display: false
                                    }
                                },
                                y: {
                                    stacked: true,
                                    min: 0,
                                    max: 100,
                                    ticks: {
                                        callback: function(value) {
                                            return value + '%';
                                        }
                                    },
                                    title: {
                                        display: false
                                    }
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for area chart');
                }
            } else if (diagrammType === 'bar') {
                const labels = chartData.labels || [];
                const datasets = chartData.datasets || [];

                // console.log('Labels:', labels);
                // console.log('Datasets:', datasets);

                if (labels.length === 0 || datasets.length === 0) {
                    console.warn('No valid data for bar chart:', chartData);
                    return;
                }

                // Process labels to split long ones into two lines
                // Chart.js supports multi-line labels when labels are arrays
                const processedLabels = labels.map(label => {
                    if (typeof label !== 'string' || label.length <= 30) {
                        return label; // Keep short labels as-is
                    }
                    
                    // Find a good split point near the middle (prefer space)
                    const midpoint = Math.floor(label.length / 2);
                    const searchStart = Math.max(0, midpoint - 10);
                    const searchEnd = Math.min(label.length, midpoint + 10);
                    const spaceIndex = label.lastIndexOf(' ', searchEnd);
                    
                    if (spaceIndex > searchStart) {
                        // Split at space
                        return [
                            label.substring(0, spaceIndex).trim(),
                            label.substring(spaceIndex).trim()
                        ];
                    } else {
                        // No space found, split at midpoint
                        return [
                            label.substring(0, midpoint).trim(),
                            label.substring(midpoint).trim()
                        ];
                    }
                });

                const canvas = element.querySelector('.chart-canvas');
                const chartWrap = element.querySelector('.chart--wrap');
                if (canvas) {
                    // Calculate minimum height based on number of labels (accounting for multi-line labels)
                    const labelCount = processedLabels.length;
                    const minHeightPerLabel = 70; // Minimum pixels per label (for multi-line)
                    const minHeight = Math.max(400, labelCount * minHeightPerLabel);
                    
                    // Set minimum height on the chart wrapper
                    if (chartWrap) {
                        chartWrap.style.minHeight = minHeight + 'px';
                    }
                    
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: processedLabels,
                            datasets: datasets.map(dataset => ({
                                label: dataset.label || 'Unknown',
                                data: dataset.data,
                                rawData: dataset.rawData,
                                backgroundColor: dataset.farbe,
                                borderWidth: 0
                            }))
                        },
                        options: {
                            indexAxis: 'y',
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    mode: 'nearest',
                                    intersect: true,
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.dataset.label || 'Unknown';
                                            const index = context.dataIndex;
                                            // Use dataset.data which contains percentage values
                                            const value = Array.isArray(context.dataset.data) && index < context.dataset.data.length
                                                ? context.dataset.data[index]
                                                : 0;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toFixed(1)
                                                : '0';
                                            return `${label}: ${formattedValue}%`;
                                        }
                                    }
                                }
                            },
                            scales: {
                                x: {
                                    min: 0,
                                    max: 100,
                                    title: {
                                        display: false
                                    },
                                    ticks: {
                                        callback: function(value) {
                                            return value + '%';
                                        }
                                    }
                                },
                                y: {
                                    title: {
                                        display: false
                                    },
                                    ticks: {
                                        // Ensure enough space for multi-line labels
                                        padding: 12,
                                        maxRotation: 0,
                                        minRotation: 0
                                    },
                                    // Increase width to accommodate multi-line labels
                                    afterFit: function(scale) {
                                        scale.width = Math.max(scale.width, 200);
                                    }
                                }
                            },
                            // Increase spacing for multi-line labels - more space between bars
                            categoryPercentage: 0.6,
                            barPercentage: 0.75,
                            layout: {
                                padding: {
                                    left: 10,
                                    right: 10,
                                    top: 10,
                                    bottom: 10
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for bar chart');
                }
            } else if (diagrammType === 's_bar') {
                const labels = chartData.labels || [];
                const datasets = chartData.datasets || [];

                // console.log('Labels:', labels);
                // console.log('Datasets:', datasets);

                if (labels.length === 0 || datasets.length === 0) {
                    console.warn('No valid data for s_bar chart:', chartData);
                    return;
                }

                // Process labels to split long ones into two lines
                // Chart.js supports multi-line labels when labels are arrays
                const processedLabels = labels.map(label => {
                    if (typeof label !== 'string' || label.length <= 30) {
                        return label; // Keep short labels as-is
                    }
                    
                    // Find a good split point near the middle (prefer space)
                    const midpoint = Math.floor(label.length / 2);
                    const searchStart = Math.max(0, midpoint - 10);
                    const searchEnd = Math.min(label.length, midpoint + 10);
                    const spaceIndex = label.lastIndexOf(' ', searchEnd);
                    
                    if (spaceIndex > searchStart) {
                        // Split at space
                        return [
                            label.substring(0, spaceIndex).trim(),
                            label.substring(spaceIndex).trim()
                        ];
                    } else {
                        // No space found, split at midpoint
                        return [
                            label.substring(0, midpoint).trim(),
                            label.substring(midpoint).trim()
                        ];
                    }
                });

                const canvas = element.querySelector('.chart-canvas');
                const chartWrap = element.querySelector('.chart--wrap');
                if (canvas) {
                    // Calculate minimum height based on number of labels (accounting for multi-line labels)
                    const labelCount = processedLabels.length;
                    const minHeightPerLabel = 70; // Minimum pixels per label (for multi-line)
                    const minHeight = Math.max(400, labelCount * minHeightPerLabel);
                    
                    // Set minimum height on the chart wrapper
                    if (chartWrap) {
                        chartWrap.style.minHeight = minHeight + 'px';
                    }
                    
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: processedLabels,
                            datasets: datasets.map(dataset => ({
                                label: dataset.label || 'Unknown',
                                data: dataset.data,
                                rawData: dataset.rawData,
                                backgroundColor: dataset.farbe,
                                borderWidth: 0
                            }))
                        },
                        options: {
                            indexAxis: 'y',
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    mode: 'nearest',
                                    intersect: true,
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.dataset.label || 'Unknown';
                                            const index = context.dataIndex;
                                            // Use dataset.data which contains percentage values
                                            const value = Array.isArray(context.dataset.data) && index < context.dataset.data.length
                                                ? context.dataset.data[index]
                                                : 0;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toFixed(1)
                                                : '0';
                                            return `${label}: ${formattedValue}%`;
                                        }
                                    }
                                }
                            },
                            scales: {
                                x: {
                                    stacked: true,
                                    min: 0,
                                    max: 100,
                                    ticks: {
                                        callback: function(value) {
                                            return value + '%';
                                        }
                                    },
                                    title: {
                                        display: false
                                    }
                                },
                                y: {
                                    stacked: true,
                                    title: {
                                        display: false
                                    },
                                    ticks: {
                                        // Ensure enough space for multi-line labels
                                        padding: 12,
                                        maxRotation: 0,
                                        minRotation: 0
                                    },
                                    // Increase width to accommodate multi-line labels
                                    afterFit: function(scale) {
                                        scale.width = Math.max(scale.width, 200);
                                    }
                                }
                            },
                            // Increase spacing for multi-line labels - more space between bars
                            categoryPercentage: 0.6,
                            barPercentage: 0.75,
                            layout: {
                                padding: {
                                    left: 10,
                                    right: 10,
                                    top: 10,
                                    bottom: 10
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for s_bar chart');
                }
            } else if (diagrammType === 'g_bar') {
                const labels = chartData.labels || [];
                const datasets = chartData.datasets || [];

                // console.log('Labels:', labels);
                // console.log('Datasets:', datasets);

                if (labels.length === 0 || datasets.length === 0) {
                    console.warn('No valid data for g_bar chart:', chartData);
                    return;
                }

                // Process labels to split long ones into two lines
                // Chart.js supports multi-line labels when labels are arrays
                const processedLabels = labels.map(label => {
                    if (typeof label !== 'string' || label.length <= 30) {
                        return label; // Keep short labels as-is
                    }
                    
                    // Find a good split point near the middle (prefer space)
                    const midpoint = Math.floor(label.length / 2);
                    const searchStart = Math.max(0, midpoint - 10);
                    const searchEnd = Math.min(label.length, midpoint + 10);
                    const spaceIndex = label.lastIndexOf(' ', searchEnd);
                    
                    if (spaceIndex > searchStart) {
                        // Split at space
                        return [
                            label.substring(0, spaceIndex).trim(),
                            label.substring(spaceIndex).trim()
                        ];
                    } else {
                        // No space found, split at midpoint
                        return [
                            label.substring(0, midpoint).trim(),
                            label.substring(midpoint).trim()
                        ];
                    }
                });

                const canvas = element.querySelector('.chart-canvas');
                const chartWrap = element.querySelector('.chart--wrap');
                if (canvas) {
                    // Calculate minimum height based on number of labels (accounting for multi-line labels)
                    const labelCount = processedLabels.length;
                    const minHeightPerLabel = 70; // Minimum pixels per label (for multi-line)
                    const minHeight = Math.max(400, labelCount * minHeightPerLabel);
                    
                    // Set minimum height on the chart wrapper
                    if (chartWrap) {
                        chartWrap.style.minHeight = minHeight + 'px';
                    }
                    
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: processedLabels,
                            datasets: datasets.map(dataset => ({
                                label: dataset.label || 'Unknown',
                                data: dataset.data,
                                rawData: dataset.rawData,
                                backgroundColor: dataset.farbe,
                                borderWidth: 0,
                                stack: dataset.stack || undefined // Use stack property for grouped stacking
                            }))
                        },
                        options: {
                            indexAxis: 'y',
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    mode: 'nearest',
                                    intersect: true,
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.dataset.label || 'Unknown';
                                            const index = context.dataIndex;
                                            // Use dataset.data which contains percentage values
                                            const value = Array.isArray(context.dataset.data) && index < context.dataset.data.length
                                                ? context.dataset.data[index]
                                                : 0;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toFixed(1)
                                                : '0';
                                            return `${label}: ${formattedValue}%`;
                                        }
                                    }
                                }
                            },
                            scales: {
                                x: {
                                    stacked: true, // Enable stacking
                                    min: 0,
                                    max: 100,
                                    title: {
                                        display: false
                                    },
                                    ticks: {
                                        callback: function(value) {
                                            return value + '%';
                                        }
                                    }
                                },
                                y: {
                                    stacked: true, // Enable stacking
                                    title: {
                                        display: false
                                    },
                                    ticks: {
                                        // Ensure enough space for multi-line labels
                                        padding: 12,
                                        maxRotation: 0,
                                        minRotation: 0
                                    },
                                    // Increase width to accommodate multi-line labels
                                    afterFit: function(scale) {
                                        scale.width = Math.max(scale.width, 200);
                                    }
                                }
                            },
                            // Increase spacing for multi-line labels - more space between bars
                            categoryPercentage: 0.6,
                            barPercentage: 0.75,
                            layout: {
                                padding: {
                                    left: 10,
                                    right: 10,
                                    top: 10,
                                    bottom: 10
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for g_bar chart');
                }
            } else if (diagrammType === 's_col') {
                const labels = chartData.labels || [];
                const datasets = chartData.datasets || [];
                const isGrouped = chartData.grouped === true;
                const groups = chartData.groups || [];
                const groupLabels = chartData.groupLabels || [];
                const groupSizes = chartData.groupSizes || [];

                if (labels.length === 0 || datasets.length === 0) {
                    console.warn('No valid data for s_col chart:', chartData);
                    return;
                }

                const canvas = element.querySelector('.chart-canvas');
                if (canvas) {
                    let finalLabels = labels;
                    let finalDatasets = datasets;
                    
                    // If grouped, insert empty labels between groups for spacing
                    if (isGrouped && groups.length > 1) {
                        finalLabels = [];
                        finalDatasets = datasets.map(dataset => ({
                            ...dataset,
                            data: [],
                            rawData: []
                        }));
                        
                        let dataIndex = 0;
                        groups.forEach((group, groupIdx) => {
                            // Add labels and data for this group
                            group.forEach((item) => {
                                finalLabels.push(item.label);
                                datasets.forEach((dataset, datasetIdx) => {
                                    if (!finalDatasets[datasetIdx].data) {
                                        finalDatasets[datasetIdx].data = [];
                                    }
                                    if (!finalDatasets[datasetIdx].rawData) {
                                        finalDatasets[datasetIdx].rawData = [];
                                    }
                                    finalDatasets[datasetIdx].data.push(dataset.data[dataIndex] || 0);
                                    finalDatasets[datasetIdx].rawData.push(dataset.rawData && dataset.rawData[dataIndex] !== undefined ? dataset.rawData[dataIndex] : 0);
                                });
                                dataIndex++;
                            });
                            
                            // Add empty label between groups (except after last group)
                            if (groupIdx < groups.length - 1) {
                                finalLabels.push('');
                                datasets.forEach((dataset, datasetIdx) => {
                                    finalDatasets[datasetIdx].data.push(null);
                                    finalDatasets[datasetIdx].rawData.push(null);
                                });
                            }
                        });
                    }
                    
                    // Plugin to draw group labels below the chart
                    const groupLabelPlugin = {
                        id: 'groupLabelPlugin',
                        afterDraw(chart) {
                            if (!isGrouped || groups.length === 0) return;
                            
                            const ctx = chart.ctx;
                            const xScale = chart.scales.x;
                            const chartArea = chart.chartArea;
                            
                            ctx.save();
                            ctx.fillStyle = '#666';
                            ctx.font = '600 12px Arial';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'top';
                            
                            let labelIndex = 0;
                            groups.forEach((group, groupIdx) => {
                                const groupSize = group.length;
                                const startIndex = labelIndex;
                                const endIndex = labelIndex + groupSize - 1;
                                
                                // Calculate center position of the group
                                const startX = xScale.getPixelForValue(startIndex);
                                const endX = xScale.getPixelForValue(endIndex);
                                const centerX = (startX + endX) / 2;
                                
                                // Draw group label below the chart (1rem = 16px further down)
                                const labelY = chartArea.bottom + 36;
                                const groupLabel = groupLabels[groupIdx] || '';
                                
                                if (groupLabel) {
                                    ctx.fillText(groupLabel, centerX, labelY);
                                }
                                
                                labelIndex += groupSize;
                                // Skip empty label between groups
                                if (groupIdx < groups.length - 1) {
                                    labelIndex++;
                                }
                            });
                            
                            ctx.restore();
                        }
                    };
                    
                    const ctx = canvas.getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        plugins: isGrouped ? [groupLabelPlugin] : [],
                        data: {
                            labels: finalLabels,
                            datasets: finalDatasets.map(dataset => ({
                                label: dataset.label || 'Unknown',
                                data: dataset.data,
                                rawData: dataset.rawData || dataset.data,
                                backgroundColor: dataset.farbe,
                                borderWidth: 0
                            }))
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: getAnimationConfig(),
                            plugins: {
                                legend: {
                                    display: false
                                },
                                title: {
                                    display: false
                                },
                                tooltip: {
                                    mode: 'nearest',
                                    intersect: true,
                                    filter: function(tooltipItem) {
                                        // Hide tooltip for empty labels (spacers)
                                        return tooltipItem.label !== '';
                                    },
                                    callbacks: {
                                        title: function() {
                                            return '';
                                        },
                                        label: function(context) {
                                            const label = context.dataset.label || 'Unknown';
                                            const index = context.dataIndex;
                                            // Use dataset.data which contains percentage values
                                            const value = Array.isArray(context.dataset.data) && index < context.dataset.data.length
                                                ? context.dataset.data[index]
                                                : 0;
                                            const formattedValue = (typeof value === 'number' && !isNaN(value))
                                                ? value.toFixed(1)
                                                : '0';
                                            return `${label}: ${formattedValue}%`;
                                        }
                                    }
                                }
                            },
                            scales: {
                                x: {
                                    stacked: true,
                                    title: {
                                        display: false
                                    },
                                    ticks: {
                                        callback: function(value, index) {
                                            // Hide labels for empty spacers
                                            const label = this.getLabelForValue(value);
                                            return label === '' ? '' : label;
                                        }
                                    }
                                },
                                y: {
                                    stacked: true,
                                    min: 0,
                                    max: 100,
                                    ticks: {
                                        callback: function(value) {
                                            return value + '%';
                                        }
                                    },
                                    title: {
                                        display: false
                                    }
                                }
                            },
                            layout: {
                                padding: {
                                    bottom: isGrouped ? 60 : 10
                                }
                            }
                        }
                    });
                } else {
                    console.warn('No .chart-canvas found for s_col chart');
                }
            }
        }
    }
});